export const HELPER_DEFAULT_PORT = 8421;
export const STUDIO_ORIGIN = "https://studio.makemonlab.studio";
export const STUDIO_ORIGIN_DEV = "http://localhost:3000";

export * from "./errors";
export * from "./types";
export * from "./tokens";
